export default "__VITE_ASSET__Ofw6qLna__"